import createReducer from '../createReducer';

const initialState = {
    queryFilter: '',
    freeFilter: '',
    crmRecipients: 0,
    crmRecipientsList: null,
    getCrmRecipientsXHR: null,
    sendCrmMessageXHR: null,
    crmWhatsappTemplate: null,
    getCrmWhatsappTemplateXHR: null,
    suspendedOrders: [],
    getSuspendedOrdersXHR: null,
    sendConfirmationsXHR: null,
    orderChangePhone: null,
    orderChangePhoneSendXHR: null,
    orderChangePhoneVerifyXHR: null,
    orderChangePhoneDirectXHR: null
};

const reducer = createReducer('crm', initialState);

export default reducer;

